export const getRemainingQuantity = (total: number, remaining: number) => {
  const half = Math.floor(total / 2)
  if (remaining <= 0) return 0
  if (remaining > 0 && remaining < half) return half
  if (remaining > 0 && remaining < total) return total
  return undefined
}
